
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    import FrontMainLandFreight from '@/store/entities/front-mainlandfreight'
    Vue.use(Preview);

    class PageFreightRequest extends PageRequest {
        site: number;
        cargoCategory: number;
        inputWeight: number = 0;
        inputLong?: number = null;
        inputWidth?: number = null;
        inputHigh?: number = null;

    }

    @Component({
        name: "mainlandfreightcalculation",
    })
    export default class Freogjt extends AbpBase {
        whetherStatus = Enums.getEnum(Enums.IsEffectiveStatus, true);
        cargoCategoryType = Enums.getEnum(Enums.CargoCategoryType, true);
        siteType = Enums.getEnum(Enums.SiteSType, true);
        pagerequest: PageFreightRequest = new PageFreightRequest();
        FreightData: any = {};
        FreightModel: Array<any> = [];
        FreightResult: Array<any> = [];


        get list() {
            return this.$store.state.frontmainlandfeightinfo.list;
        };
        get loading() {
            return this.$store.state.frontmainlandfeightinfo.loading;
        }
        async searchPage() {
            this.$store.state.frontmainlandfeightinfo.currentPage = 1;
            this.getpage();
        }

        pageChange(page: number) {
            this.$store.commit('frontmainlandfeightinfo/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('frontmainlandfeightinfo/setPageSize', pagesize);
            this.getpage();
        }
        async startCalculation(num) {
             var _this: any = this;
            if (_this.pagerequest.inputWeight == 0) {
                _this.$Message.error('重量不能为空！');
                return;
            }
            else if (!this.pagerequest.inputLong || !_this.pagerequest.inputWidth || !_this.pagerequest.inputHigh) {
                _this.$Message.error('长宽高不能为空！');
                return;
            }
            this.$store.state.frontmainlandfeightinfo.list.forEach(function (arr, index, value) {
             
                var data: any = { Id: arr.id, FirstWeight: arr.firstWeight, BulkyParameter: arr.bulkyParameter, FirstWeightPrice: arr.firstWeightPrice, ContinueWeight: arr.continueWeight, ContinueWeightCost: arr.continueWeightCost, inputWeight: _this.pagerequest.inputWeight, inputLong: _this.pagerequest.inputLong, inputWidth: _this.pagerequest.inputWidth, inputHigh: _this.pagerequest.inputHigh, Result: arr.result };
                
                _this.FreightModel.push(data);
            });
            this.FreightData = await this.$store.dispatch({
                type: 'frontmainlandfeightinfo/getFreightModel',
                data: { FreightModels: this.FreightModel }
            });
            _this.FreightModel = [];
            this.FreightData.freightModels.forEach(function (arr, index, value) {
                _this.FreightResult.push(arr);

            });
            await this.getpage();
            _this.FreightResult.splice(0, _this.FreightResult.length);

    }




        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters
            await this.$store.dispatch({
                type: 'frontmainlandfeightinfo/getAll',
                data: this.pagerequest
            })
           
        }
        get pageSize() {
            return this.$store.state.frontmainlandfeightinfo.pageSize;
        }
        get totalCount() {
            return this.$store.state.frontmainlandfeightinfo.totalCount;
        }
        get currentPage() {
            return this.$store.state.frontmainlandfeightinfo.currentPage;
        }
        columns = [
           {
                title: '仓库',
                key: 'warehouseName',
                width: 150,
                fixed: 'left',
            }, {
                title: '订单站点',
                width: 140,
                key: 'site',
                render: (h: any, params: any) => {
                    return h('span', Enums.SiteSType.filter(function (item) { return item.value == params.row.site })[0].name);
                }
            }, {
                title: '货物类别',
                width: 140,
                key: 'cargoCategory',
                render: (h: any, params: any) => {
                    return h('span', Enums.CargoCategoryType.filter(function (item) { return item.value == params.row.cargoCategory })[0].name);
                }
            }, {
                title: '首重【g】',
                key: 'firstWeight',
                width: 100,
            }, {
                title: '首重价格',
                key: 'firstWeightPrice',
                width: 100,
            }, {
                title: '续重【g】',
                key: 'continueWeight',
                width: 100,
            },
            {      
                title: '续重费用',
                key: 'continueWeightCost',
                width: 100,
            }, {
                title: '体积重参数',
                key: 'bulkyParameter',
                width: 100,
            },  {
                title: '是否有效',
                width: 100,
                key: 'isEffective',
                render: (h: any, params: any) => {
                    return h('span', params.row.isEffective ? this.L('是') : this.L('否'))
                }
            }, {
                title: '开始时间',
                key: 'beginTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.beginTime ? DateUtils.formatLongDate(new Date(params.row.beginTime)) : '');
                }
            }, {
                title: '结束时间',
                key: 'endTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.endTime ? DateUtils.formatLongDate(new Date(params.row.endTime)) : '');
                }
            },{
                title: '结果',
                key: 'result',
                width: 150,
                render: (h: any, params: any) => {
                    var _this = this;
                    var result = '';
                    if (_this.FreightResult.length > 0) {
                        var pipei = _this.FreightResult.filter(function (item) { return item.id == params.row.id });
                        if (pipei.length > 0) {
                            result = pipei[0].result;
                        }
                    }
                    return h('span', result)

                }
            },]
        async created() {

            this.getpage();
            //this.start();
        }
    }
